<template>
  <div>
    <form @submit.prevent="submit()">

      <div class="mb-3">
        <SGPFormInputComponent
          type="text"
          name="nome"
          v-model="formulario.nome"
          placeholder="Nome"
          data-vv-as="Nome"
          v-validate="'required|min:3'"
          :error="validationErrors.first('nome')"
        />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent
          name="descricao"
          type="textarea"
          rows="3"
          placeholder="Descrição"
          data-vv-as="Descrição"
          :error="validationErrors.first('descricao')"
          v-model="formulario.descricao"
        />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent
          type="text"
          name="slug"
          v-model="formulario.slug"
          placeholder="Slug (ex: ctrl-modulos)"
          data-vv-as="Slug"
          v-validate="'required|min:3'"
          :error="validationErrors.first('slug')"
        />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent
          type="text"
          name="icon"
          v-model="formulario.icon"
          placeholder="Ícone (ex: mdi-layers-outline)"
          data-vv-as="Ícone"
          :error="validationErrors.first('icon')"
        />
      </div>

      <div class="container-botoes">
        <button
          class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
          type="submit"
        >
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>

        <button
          class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
          type="button"
          @click="fecharModal()"
        >
          Cancelar
        </button>
      </div>

    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormularioModuloComponent',

  props: {
    tipoFormulario: {
      type: String,
      default: 'salvar'
    },
    modulo: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      slugEditado: false,
      atualizandoSlugAuto: false,
      formulario: { ...this.$props.modulo } || {
        nome: '',
        slug: '',
        descricao: '',
        icon: ''
      }
    }
  },

  watch: {
    'formulario.nome'(val) {
      if (!this.slugEditado) {
        this.atualizandoSlugAuto = true
        this.formulario.slug = this.gerarSlug(val)
        this.$nextTick(() => { this.atualizandoSlugAuto = false })
      }
    },
    'formulario.slug'() {
      if (!this.atualizandoSlugAuto && this.tipoFormulario === 'salvar') {
        this.slugEditado = true
      }
    }
  },

  methods: {
    ...mapActions('ctrlModulos', ['salvarModulo', 'atualizarModulo']),

    submit() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return

        if (this.tipoFormulario === 'salvar') {
          const resp = await this.salvarModulo(this.formulario)
          if (!resp) return
        } else {
          const resp = await this.atualizarModulo(this.formulario)
          if (!resp) return
        }

        this.fecharModal()
      })
    },

    fecharModal() {
      this.$parent.$parent.$parent.$parent.fecharModal()
    },

    gerarSlug(texto) {
      return (texto || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
    }
  }
}
</script>
